import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { getSignalement } from '../../api/signalements';
import { useAuthenticatedFetch } from '../../hooks'
import { useTranslation } from 'react-i18next';
import zIndex from '@material-ui/core/styles/zIndex';


// Styles pour le modal
const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    borderRadius: '10px',
    border: 'none',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
    fontFamily: 'Montserrat, sans-serif',
    maxHeight: '80vh',
    overflow: 'hidden',
    //width: "70%",
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex : 1001
  },
};

// Autres styles
const headerStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#5BBCEA',
  padding: '20px',
  position: 'relative',
  borderTopLeftRadius: '10px',
  borderTopRightRadius: '10px',
};
const closeButtonStyle = {
  position: 'absolute',
  right: '15px',
  backgroundColor: 'transparent',
  padding: '0',
  color: "white",
  border: 'none',
  borderRadius: '50%',
  width: '35px',
  height: '35px',
  cursor: 'pointer',
  fontSize: '22px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
  transition: 'background-color 0.3s, color 0.3s',
};
const contentStyle = {
  padding: '20px',
  background: '#F7F8F8',
  overflowY: 'auto',
  maxHeight: 'calc(80vh - 60px)',
  fontFamily: 'Montserrat',
};
const details = {
  padding: "15px",
  marginTop: '10px',
  marginBottom: "10px",
  borderTop: '1px solid #D9D9D9A8',
  overflowWrap : "anywhere",
  whiteSpace : "normal"
};
const detailsTitle = {
  color: "#333333",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: '19.5px',
};
const detailsSpan = {
  color: "#606060",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: '19.5px',
};
const title = {
  color: '#25A6E4',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '19.5px',
};
const documentListStyle = {
  listStyleType: 'none',
  padding: 0,
  marginTop: '10px',
};
const documentItemStyle = {
  marginBottom: '10px',
};

// Composant principal
const DetailsSignalementModal = ({ isOpen, onClose, signalementId }) => {
  const [chargementEnCours, setChargementEnCours] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const [signalement, setSignalement] = useState(null);
  const [fileUrls, setFileUrls] = useState({});
  const {t} = useTranslation();
  const {
          fetchResource,
          error: fetchError,
          loading: fetchLoading,
    } = useAuthenticatedFetch()

    
    const loadFileUrls = async () => {
      if (!signalement?.files?.length) return;
  
      const urls = {};
      for (const file of signalement.files) {
        try {
          const url = await fetchResource(file.path, token);
          urls[file.path] = url;
        } catch (error) {
          console.error('Erreur lors du chargement du fichier :', error);
        }
      }
      setFileUrls(urls);
    };
    

  const fetchSignalement = async (signalementId) => {
    setChargementEnCours(true);
    try {
      const data = await getSignalement(signalementId, token);
      setSignalement(data);
      
    } catch (error) {
      toast.error(t("transfer_request_err"), {
        style: { fontFamily: 'Montserrat' },
      });
    } finally {
      setChargementEnCours(false);
    }
  };

  const typeLabels = {
    client_absent: "Client absent",
    retard_aux_chargement: t("loading_delay"),
    livraison_reportée: t("delivery_postponed"),
    retard_aux_déchargement: t("unloading_delay"),
    marchandises_manquantes_chargement: t("missing_goods"),
    marchandise_refusée: t("goods_refused"),
    marchandises_incomplètes: t("incomplete_goods"),
    marchandise_abîmée: t("damaged_goods"),
    route_inaccessible_fermée: t("road_inaccessible"),
    circulation_dense: t("heavy_traffic")
  };
  useEffect(() => {
    if (signalementId && isOpen) {
      fetchSignalement(signalementId);
    }
  }, [signalementId, isOpen]);

  useEffect(() => {
    if (signalement?.files?.length > 0) {
      loadFileUrls();
    }
  }, [signalement]);

  const renderDocuments = (documents) => {
    if (!documents || documents.length === 0) {
      return <p style={detailsSpan}>Aucun document associé</p>;
    }

    return (
      <ul style={documentListStyle}>
        {documents.map((doc) => (
          <li key={doc._id} style={documentItemStyle}>
            {doc.mimetype.startsWith('image/') ? (
              <a href={`${fileUrls[doc.path] }`} target="_blank" rel="noopener noreferrer">
                <img
                  src={`${fileUrls[doc.path] }`}
                  alt={doc.name}
                  style={{ maxWidth: '100px', maxHeight: '100px', marginRight: '10px' }}
                />
              </a>
            ) : (
              <p  style={detailsTitle}>
                              <a href={`${fileUrls[doc.path] }`} target="_blank" rel="noopener noreferrer">
                                {doc?.name}
                              </a>
              </p>
            )}
          </li>
        ))}
      </ul>
    );
  };
const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth <= 768);
  
  
    useEffect(() => {
      const checkIfMobile = () => {
        setSmallScreen(window.innerWidth <= 768);
      };
      window.addEventListener('resize', checkIfMobile);
  
      return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      style={{content: {
      ...modalStyles.content,
      width: isSmallScreen ? "90%" : "60%",
    },
    overlay : modalStyles.overlay
  }

  }
    >
      <div style={headerStyle}>
        <h3 style={{ color: 'white', margin: 0, flex: 1, textAlign: 'center' }}>
          {t( "report_details" )}
        </h3>
        <button onClick={onClose} style={closeButtonStyle}>
          X
        </button>
      </div>
      {chargementEnCours ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
            marginTop: "2rem",
            marginBottom: "2rem",
          }}
        >
          <div className='customLoader'></div>
        </div>
      ) : (
        <div style={contentStyle}>
          <div style={details}>
          <p style={detailsTitle}>
            {t("mission_number")} :{' '}
              <span style={detailsSpan}>{signalement?.mission_index}</span>
         </p>
            <p style={detailsTitle}>
              {t("anomaly_type")} :{' '}
              <span style={detailsSpan}>{typeLabels[signalement?.type] }</span>
            </p>
            <p style={detailsTitle}>
              {t("stop_point_address")} :{' '}
              <span style={detailsSpan}>{signalement?.points_passage?.adresse?.label}</span>
            </p>
            <p style={detailsTitle}>
              Note : <span style={detailsSpan}>{signalement?.note}</span>
            </p>
          </div>

          <div style={details}>
            <span style={title}>{t("recipient_info")}</span>
            <p style={detailsTitle}>
              {t("contact_us_formulair_item1")} :{' '}
              <span style={detailsSpan}>
              {signalement?.points_passage?.nom_destinataire || t("not_provided")}{' '}
              {signalement?.points_passage?.prénom_destinataire || ''}
              </span>
            </p>
            <p style={detailsTitle}>
              {t("contact_us_formulair_item2")} :{' '}
              <span style={detailsSpan}>
              {signalement?.points_passage?.téléphone_destinataire || t("not_provided")}
                </span>
            </p>
            <p style={detailsTitle}>
              {t("email")} :{' '}
              <span style={detailsSpan}>
              {signalement?.points_passage?.email_destinataire || t("not_provided")}
                </span>
            </p>
            <p style={detailsTitle}>
              {t("entreprise_name")} :{' '}
              <span style={detailsSpan}>
              {signalement?.points_passage?.nom_entreprise || t("not_provided")}
              </span>
            </p>
          </div>

          <div style={details}>
            <span style={title}>{t("associated_documents")}</span>
            {renderDocuments(signalement?.files)}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DetailsSignalementModal;
